import { type RecType } from '@/defs/rec'
import { formatPercentage } from '@/utils/formatUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'
import { StatRecInclusionTooltip } from '../StatRecInclusionTooltip/StatRecInclusionTooltip'

type Props = {
  isInView?: boolean
  rec: RecType
}

export const StatRecInclusion = ({ isInView, rec }: Props) => {
  const { inclusion } = rec

  return (
    <StatCommonBox isInView={isInView} label='Inclusion' popover={<StatRecInclusionTooltip rec={rec} />}>
      <StatCommonFigure suffix='%'>{formatPercentage(inclusion ?? 0)}</StatCommonFigure>
    </StatCommonBox>
  )
}
